import req from "../http";

const driverLicense = {
  // 取得 駕照
  getDriverLicense(params) {
    return req("get", "/BasicInformation/DriverLicenseCategory/WithDetail", params);
  },
};

export default driverLicense;